/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import _ from "lodash";
import { apiPatch } from "../Api/apiCall";
import { getProductData } from "../Product/ProductService/productService";
import { getUpdateData, persistAddress, persistPerson } from "./persisterService";
import { persistLitigationSubEntities } from "./AbstractLitigationCasePersister";
import { UseForm } from "../../types/UseForm";
import { TrafficAccident } from "../../types/Products/TrafficLaw/TrafficAccident/TrafficAccident";
import ApiClient from "../ApiClient";

export const persistTrafficAccident = async (
  updateData: UseForm["values"],
  origTrafficAccidentCase: TrafficAccident
) => {
  await persistLitigationSubEntities(updateData, origTrafficAccidentCase);

  if (_.has(updateData, "accidentAddress") && _.isObject(updateData.accidentAddress)) {
    const accidentAddressUpdateData = getUpdateData(
      updateData.accidentAddress,
      origTrafficAccidentCase,
      "accidentAddress"
    );
    await persistAddress(origTrafficAccidentCase.accidentAddress.id, accidentAddressUpdateData);
  }

  if (_.has(updateData, "driverPerson") && _.isObject(updateData.driverPerson)) {
    const driverPersonUpdateData = getUpdateData(updateData.driverPerson, origTrafficAccidentCase, "driverPerson");
    await persistPerson(origTrafficAccidentCase.driverPerson.id, driverPersonUpdateData);
  }

  if (_.has(updateData, "driverPerson.residenceAddress") && _.isObject(updateData.driverPerson.residenceAddress)) {
    const driverPersonAddressUpdateData = getUpdateData(
      updateData.driverPerson.residenceAddress,
      origTrafficAccidentCase,
      "driverPerson.residenceAddress"
    );
    await persistAddress(origTrafficAccidentCase.driverPerson.residenceAddress.id, driverPersonAddressUpdateData);
  }

  if (_.has(updateData, "opposingCarLiabilityInsurance.organization")) {
    if (origTrafficAccidentCase.opposingCarLiabilityInsurance) {
      await ApiClient.patch(`case_organizations/${origTrafficAccidentCase.opposingCarLiabilityInsurance.id}`, {
        body: JSON.stringify(updateData.opposingCarLiabilityInsurance),
      });
    } else {
      await ApiClient.post(`case_organizations`, {
        body: JSON.stringify({
          case: origTrafficAccidentCase["@id"],
          organization: updateData.opposingCarLiabilityInsurance.organization,
        }),
      });
    }
  }

  const apiUri = getProductData(origTrafficAccidentCase.productClassName, "apiUri");
  const contractCaseUpdateData = getUpdateData(updateData, origTrafficAccidentCase);

  if (_.isObject(updateData.claimsForDamages)) {
    contractCaseUpdateData.claimsForDamages = updateData.claimsForDamages;
  }

  await apiPatch(apiUri, origTrafficAccidentCase.id, contractCaseUpdateData);
};
